import { useState } from 'react';
import { useDispatch } from 'react-redux';
import arcLogo from '@/assets/images/arcweb.svg';
import loginImage from '@/assets/images/login-image.jpg';
import AtomButton from '@/components/atoms/Button';
import loginStyles from '@/pages/Login/login.module.css';
import { AppDispatch } from '../../store';
import { auth } from '../../store/auth/thunks';
// import useSnackbar from '@/hooks/useSnackbar';
// import AtomTextField from '@/components/atoms/TextField';

const Login = () => {
  // const snackbar = useSnackbar();
  const dispatch = useDispatch<AppDispatch>();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const loginWithMicrosoft = async () => {
    // snackbar.showInfo('Operation completed successfully!');
    try {
      setIsLoading(true);
      const resultAction = await dispatch(auth.login());
      if (auth.login.fulfilled.match(resultAction)) {
        setIsLoading(false);
        window.location.href = resultAction.payload.auth_url;
      } else if (auth.login.rejected.match(resultAction)) {
        setIsLoading(false);
        console.error('Login failed:', resultAction.error);
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'An unexpected error occurred';
      console.error('Login error:', errorMessage);
    }
  };
  // Your component logic here
  return (
    <div className={loginStyles.container}>
      <div className={loginStyles.imageSection}>
        <img src={loginImage} alt="data-image" />
      </div>
      <div className={loginStyles.contentSection}>
        <img className={loginStyles.logo} src={arcLogo} alt="data-image" />
        <div className={loginStyles.header}>
          <h2>Welcome to the ARC Research Platform!</h2>
        </div>
        {/* <AtomTextField className={loginStyles.textField} variant="outlined" label="Username" />
        <AtomTextField
          className={loginStyles.textField}
          variant="outlined"
          label="Password"
          type="password"
        /> */}

        <AtomButton
          variant="contained"
          onClick={loginWithMicrosoft}
          className={loginStyles.loginButton}
          disableElevation
          loading={isLoading}
        >
          Sign in with microsoft
        </AtomButton>
      </div>
    </div>
  );
};

export default Login;
